import React, { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ReactComponent as EmptyBlockIcon } from "assets/images/empty-block-icon.svg";

import { styles } from "./styles";

interface EmptyStateProps {
  message?: ReactNode;
  icon?: ReactNode;
}

const EmptyState: FC<EmptyStateProps> = (props) => {
  const { message = "Немає даних", icon = <EmptyBlockIcon /> } = props;

  return (
    <Stack sx={styles.emptyState}>
      {icon}
      <Box sx={{ pt: 2, maxWidth: 220 }}>
        {typeof message === "string" ? (
          <Typography
            color="grey700"
            textAlign="center"
            sx={{ whiteSpace: "pre-line" }}
          >
            {message}
          </Typography>
        ) : (
          message
        )}
      </Box>
    </Stack>
  );
};

export default EmptyState;
